/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorInterview,
  PharmacyCounselorInterviewFromJSON,
  PharmacyCounselorInterviewFromJSONTyped,
  PharmacyCounselorInterviewToJSON,
  PharmacyCounselorInterviewPatient,
  PharmacyCounselorInterviewPatientFromJSON,
  PharmacyCounselorInterviewPatientFromJSONTyped,
  PharmacyCounselorInterviewPatientToJSON,
} from "./";

export const GetInterviewResponseTypename = "GetInterviewResponse" as const;

/**
 *
 * @export
 * @interface GetInterviewResponse
 */
export interface GetInterviewResponse {
  /**
   *
   * @type {PharmacyCounselorInterview}
   * @memberof GetInterviewResponse
   */
  interview?: PharmacyCounselorInterview;
  /**
   *
   * @type {PharmacyCounselorInterviewPatient}
   * @memberof GetInterviewResponse
   */
  patient: PharmacyCounselorInterviewPatient;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetInterviewResponse
   */
  readonly __typename?: string;
}

export function GetInterviewResponseFromJSON(json: any): GetInterviewResponse {
  return GetInterviewResponseFromJSONTyped(json, false);
}

export function GetInterviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInterviewResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetInterviewResponseTypename,

    interview: !exists(json, "interview") ? undefined : PharmacyCounselorInterviewFromJSON(json["interview"]),
    patient: PharmacyCounselorInterviewPatientFromJSON(json["patient"]),
  };
}

export function GetInterviewResponseToJSON(object?: GetInterviewResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    interview: PharmacyCounselorInterviewToJSON(value.interview),
    patient: PharmacyCounselorInterviewPatientToJSON(value.patient),
  };
}
